class PdfOverview extends HTMLElement {
  constructor() {
    super();
    this.searchInput = this.querySelector('[type="search"]');
    this.items = Array.from(this.querySelectorAll('[data-pdf-item]'));
    this.resultsCount = this.querySelector('[data-pdf-results-count]');
    this.noResults = this.querySelector('[data-pdf-no-results]');
    this.noResultsText = this.querySelector('[data-pdf-no-results-text]');
    this.resultsSingularTemplate = this.dataset.resultsSingularTemplate || '1 result';
    this.resultsPluralTemplate = this.dataset.resultsPluralTemplate || '[count] results';
    this.noResultsTemplate = this.dataset.noResultsTemplate || 'No results for "[terms]".';
  }

  connectedCallback() {
    if (!this.searchInput) return;

    this.searchInput.addEventListener('input', () => this.filterItems());
  }

  filterItems() {
    const searchTerm = this.searchInput.value.trim().toLowerCase();
    let visibleCount = 0;

    for (const item of this.items) {
      const searchText = item.dataset.pdfSearch || item.textContent.toLowerCase();
      const isVisible = searchTerm === '' || searchText.includes(searchTerm);

      item.hidden = !isVisible;

      if (isVisible) {
        visibleCount += 1;
      }
    }

    this.updateResults(searchTerm, visibleCount);
  }

  updateResults(searchTerm, visibleCount) {
    const isSearching = searchTerm !== '';

    if (this.resultsCount) {
      const resultsTemplate = visibleCount === 1 ? this.resultsSingularTemplate : this.resultsPluralTemplate;

      this.resultsCount.hidden = !isSearching;
      this.resultsCount.textContent = isSearching
        ? resultsTemplate.replace('[count]', visibleCount)
        : '';
    }

    if (this.noResults) {
      const hasNoResults = isSearching && visibleCount === 0;
      this.noResults.hidden = !hasNoResults;
    }

    if (this.noResultsText) {
      this.noResultsText.textContent = this.noResultsTemplate.replace('[terms]', searchTerm);
    }
  }
}

customElements.define('pdf-overview', PdfOverview);
